export default __webpack_public_path__ + "static/background-home-ffbc5fe1413b88e11db8a41792062163.png";